<div class="munkaterv-fejlec">
  <ion-select [(ngModel)]="ev" (ionChange)="valt(ev, null)" interface="popover" label="Év" style="max-width:120px">
    <ion-select-option *ngFor="let y of [ev+1, ev, ev-1, ev-2]" [value]="y">{{ y }}</ion-select-option>
  </ion-select>
  <ion-select [(ngModel)]="ho" (ionChange)="valt(null, ho)" interface="popover" label="Beadási hónap" style="max-width:160px">
    <ion-select-option *ngFor="let h of honapok" [value]="h">{{ h }}. hó</ion-select-option>
  </ion-select>
  <ion-chip color="primary"><ion-label>Össz: {{ terv.osszes }}</ion-label></ion-chip>
  <ion-chip color="success"><ion-label>Beadva: {{ terv.kesz }}</ion-label></ion-chip>
  <ion-chip [color]="terv.hatra ? 'danger' : 'medium'"><ion-label>Hátra: {{ terv.hatra }}</ion-label></ion-chip>
  <ion-button fill="clear" size="small" (click)="csakHatra = !csakHatra">
    <ion-icon slot="start" [name]="csakHatra ? 'funnel' : 'funnel-outline'"></ion-icon>{{ csakHatra ? 'Mind' : 'Csak hátralévő' }}
  </ion-button>
  <!-- A NAV-ellenőrzés cégenként kérdez; itt egy gombbal végigmegy mindegyiken. -->
  <ion-button fill="outline" size="small" [disabled]="navFut" (click)="navEllenorzes()"
              title="Végigkérdezi a NAV-ot minden cégnél, ahol a NAV-kapcsolat (M2M) be van állítva: mit hiányol még">
    <ion-icon slot="start" [name]="navFut ? 'hourglass-outline' : 'shield-checkmark-outline'"></ion-icon>
    {{ navFut ? (navHalad?.uzenet || 'NAV-ellenőrzés…') : 'NAV-ellenőrzés' }}
  </ion-button>
  <!-- Befizetési értesítő: a hónap befizetendői levélben az ügyfeleknek (tömegesen, előnézettel). -->
  <ion-button fill="outline" size="small" (click)="tomegesNyit()" title="Levél az ügyfeleknek a hónap befizetendőiről – az elkészült bevallásokból, NAV-számlaszámmal, bér-mellékletekkel">
    <ion-icon slot="start" name="mail-outline"></ion-icon>Befizetési értesítők
  </ion-button>
  <ion-chip *ngIf="terv.nav?.ugyfel_db" [color]="terv.nav.hianyzo_db ? 'danger' : 'medium'"
            [title]="'Utolsó NAV-lekérdezés: ' + (terv.nav.lekerve || '—')">
    <ion-label>NAV: {{ terv.nav.hianyzo_db ? terv.nav.hianyzo_db + ' hiányzó' : 'nincs hiány' }} ({{ terv.nav.ugyfel_db }} cég)</ion-label>
  </ion-chip>
</div>

<!-- Nézetváltó + (fordított nézetnél) nyomtatvány-szűrő -->
<div class="munkaterv-fejlec" style="margin-top:-4px">
  <ion-segment [(ngModel)]="nezet" style="max-width:360px">
    <ion-segment-button value="ceg"><ion-label>Cégenként</ion-label></ion-segment-button>
    <ion-segment-button value="nyomtatvany"><ion-label>Nyomtatványonként</ion-label></ion-segment-button>
  </ion-segment>
  <ion-select *ngIf="nezet === 'nyomtatvany'" [(ngModel)]="szurtSablon" interface="popover" label="Nyomtatvány" style="max-width:280px">
    <ion-select-option value="">Mind</ion-select-option>
    <ion-select-option *ngFor="let s of sablonLista" [value]="s.kod">{{ s.nev }}</ion-select-option>
  </ion-select>
</div>

<!-- CÉGENKÉNTI NÉZET -->
<div class="tabla-wrap" *ngIf="nezet === 'ceg' && cegSorok.length">
  <table class="naplo-tabla munkaterv-tabla">
    <thead><tr>
      <th>Cég</th><th>Nyomtatvány</th><th>Tárgyidőszak</th><th>Határidő</th>
      <th class="kozep">Beadva</th><th class="kozep">Nyugta</th><th class="kozep">Email</th><th class="kozep">Offline</th><th>NAV</th>
    </tr></thead>
    <tbody>
      <ng-container *ngFor="let sor of cegSorok">
        <tr *ngFor="let f of sor.feladatok; let i = index" [class.kesz-sor]="f.teljesitve">
          <td><ng-container *ngIf="i === 0">{{ sor.nev }}
            <button type="button" class="mt-level" (click)="levelNyit(sor.ugyfel_id)" title="Befizetési értesítő ennek az ügyfélnek (előnézettel)">
              <ion-icon name="mail-outline"></ion-icon>Értesítő</button>
            <div class="mt-forma">
              <span class="cimke" [title]="sor.cegforma_becsult ? 'A cégforma a névből becsült – az ügyféladatoknál pontosítható' : 'Cégforma (ügyféladat)'">{{ sor.cegforma_nev }}{{ sor.cegforma_becsult ? ' ?' : '' }}</span>
              <span class="cimke sarga" *ngIf="sor.afa_gyak_hianyzik" title="Az ÁFA-bevallás gyakorisága nincs megadva az ügyféladatoknál – negyedévesnek vettük">ÁFA-gyakoriság?</span>
            </div></ng-container></td>
          <td [title]="f.miert || ''">{{ f.nev }}
            <span class="cimke sarga" *ngIf="f.bizonytalan" title="A partner országa nem ismert – ha uniós, kell; ha harmadik országbeli, nem">ellenőrizendő</span>
            <!-- A programból beadott bevallás: megnyitás nyomtatásra (PDF), gépi beküldésnél az igazolás is. -->
            <ng-container *ngIf="f.bevallas">
              <button type="button" class="mt-level" (click)="bevallasNyit(f.bevallas)" [disabled]="pdfFut === f.bevallas.id"
                      title="A beadott bevallás PDF-je új lapon">
                <ion-icon name="document-text-outline"></ion-icon>{{ pdfFut === f.bevallas.id ? 'PDF készül…' : 'PDF' }}</button>
              <button type="button" class="mt-level" *ngIf="f.bevallas.m2m" (click)="m2mIgazolas(f.bevallas)" title="Igazolás a gépi (M2M) beküldésről – PDF">
                <ion-icon name="ribbon-outline"></ion-icon>Igazolás</button>
            </ng-container>
            <div class="halvany datum" *ngIf="f.miert">{{ f.miert }}</div></td>
          <td>{{ f.idoszak }}</td>
          <td>{{ f.hatarido }}</td>
          <td class="kozep">
            <ion-checkbox [checked]="f.teljesitve" [disabled]="f.beadva_auto" [title]="f.beadva_auto ? autoCim(f) : ''" (ionChange)="toggle(sor.ugyfel_id, f, 'beadva')"></ion-checkbox>
            <div class="halvany datum" *ngIf="f.teljesitve_datum">{{ f.teljesitve_datum }}</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="f.nyugta" [disabled]="f.nyugta_auto" [title]="f.nyugta_auto ? autoCim(f) : ''" (ionChange)="toggle(sor.ugyfel_id, f, 'nyugta')"></ion-checkbox>
            <div class="halvany datum" *ngIf="f.nyugta_datum">{{ f.nyugta_datum }}</div>
            <div class="halvany datum" *ngIf="f.nyugta_auto" [title]="autoCim(f)">tárhelyről</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="f.email" (ionChange)="toggle(sor.ugyfel_id, f, 'email')"></ion-checkbox>
            <div class="halvany datum" *ngIf="f.email_datum">{{ f.email_datum }}</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="f.offline" (ionChange)="toggle(sor.ugyfel_id, f, 'offline')"></ion-checkbox>
            <div class="halvany datum" *ngIf="f.offline_datum">{{ f.offline_datum }}</div>
          </td>
          <!-- Mit mond a NAV: csak a cég első sorában, hogy ne ismétlődjön. -->
          <td *ngIf="i === 0" [attr.rowspan]="sor.feladatok.length" class="nav-cella">
            <span class="cimke" *ngIf="sor.nav" [class.piros]="sor.nav.hianyzo_db" [class.zold]="!sor.nav.hianyzo_db"
                  [title]="'Lekérdezve: ' + (sor.nav.lekerve || '—')">{{ navAllapot(sor) }}</span>
            <div class="halvany datum" *ngFor="let h of (sor.nav?.hianyzo || [])">
              {{ h.kod || '' }} {{ h.megnevezes || '' }} {{ h.idoszak || '' }}
            </div>
            <span class="halvany" *ngIf="!sor.nav">—</span>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- FORDÍTOTT (NYOMTATVÁNYONKÉNTI) NÉZET -->
<div class="tabla-wrap" *ngIf="nezet === 'nyomtatvany' && nyomtatvanySorok.length">
  <table class="naplo-tabla munkaterv-tabla">
    <thead><tr>
      <th>Cég</th><th>Tárgyidőszak</th><th>Határidő</th>
      <th class="kozep">Beadva</th><th class="kozep">Nyugta</th><th class="kozep">Email</th><th class="kozep">Offline</th>
    </tr></thead>
    <tbody>
      <ng-container *ngFor="let g of nyomtatvanySorok">
        <tr class="csoport-fej"><td colspan="7"><b>{{ g.nev }}</b> · {{ g.tetelek.length }} cég</td></tr>
        <tr *ngFor="let t of g.tetelek" [class.kesz-sor]="t.f.teljesitve">
          <td>{{ t.ceg }}</td>
          <td>{{ t.f.idoszak }}</td>
          <td>{{ t.f.hatarido }}</td>
          <td class="kozep">
            <ion-checkbox [checked]="t.f.teljesitve" [disabled]="t.f.beadva_auto" [title]="t.f.beadva_auto ? autoCim(t.f) : ''" (ionChange)="toggle(t.ugyfel_id, t.f, 'beadva')"></ion-checkbox>
            <div class="halvany datum" *ngIf="t.f.teljesitve_datum">{{ t.f.teljesitve_datum }}</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="t.f.nyugta" [disabled]="t.f.nyugta_auto" [title]="t.f.nyugta_auto ? autoCim(t.f) : ''" (ionChange)="toggle(t.ugyfel_id, t.f, 'nyugta')"></ion-checkbox>
            <div class="halvany datum" *ngIf="t.f.nyugta_datum">{{ t.f.nyugta_datum }}</div>
            <div class="halvany datum" *ngIf="t.f.nyugta_auto" [title]="autoCim(t.f)">tárhelyről</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="t.f.email" (ionChange)="toggle(t.ugyfel_id, t.f, 'email')"></ion-checkbox>
            <div class="halvany datum" *ngIf="t.f.email_datum">{{ t.f.email_datum }}</div>
          </td>
          <td class="kozep">
            <ion-checkbox [checked]="t.f.offline" (ionChange)="toggle(t.ugyfel_id, t.f, 'offline')"></ion-checkbox>
            <div class="halvany datum" *ngIf="t.f.offline_datum">{{ t.f.offline_datum }}</div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- ÜRES ÁLLAPOT -->
<div class="ures" *ngIf="(nezet === 'ceg' && !cegSorok.length) || (nezet === 'nyomtatvany' && !nyomtatvanySorok.length)">
  <ion-icon name="checkmark-done-circle-outline"></ion-icon>
  {{ csakHatra && terv.osszes ? 'Minden nyomtatvány beadva erre a hónapra.' : 'Nincs esedékes nyomtatvány erre a beadási hónapra.' }}
</div>

<!-- ═══ BEFIZETÉSI ÉRTESÍTŐ – EGY CÉG ═══ -->
<ion-modal [isOpen]="!!level" (didDismiss)="level = null" class="ber-urlap-modal ber-szeles-modal" cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Befizetési értesítő – {{ level?.ugyfel?.nev }}</ion-title>
      <ion-buttons slot="end"><ion-button (click)="level = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs" *ngIf="level as l">
      <div class="bf">
        <p class="halvany bf-sugo">{{ ev }}. {{ ho }}. havi beadás – az elkészült bevallások befizetendői, a NAV beszedési számlájával. A sorok szerkeszthetők;
          a számlaszám az adónemből töltődik. Csak a pozitív összegű sorok kerülnek a levélbe.</p>
        <p class="bf-korabban" *ngIf="l.korabban?.length"><ion-icon name="alert-circle-outline"></ion-icon>
          Ebben a hónapban már ment levél: {{ l.korabban[0].kuldve }} → {{ l.korabban[0].cimzett }}</p>
        <label class="kv-mezo"><span>Címzett</span><input type="text" [(ngModel)]="l.cimzett" placeholder="e-mail cím (több: vesszővel)"></label>
        <label class="kv-mezo"><span>Tárgy</span><input type="text" [(ngModel)]="l.targy"></label>
        <label class="kv-mezo bf-szoveg"><span>Szöveg</span><textarea rows="5" [(ngModel)]="l.szoveg" (ngModelChange)="levelHtml = null"></textarea></label>

        <div class="tabla-wrap" style="margin:0">
          <table class="n-racs bf-tabla">
            <thead><tr><th>Bevallás</th><th>Időszak</th><th>Adónem</th><th>NAV számlaszám</th>
              <th class="num" title="A bevallás szerinti kötelezettség – ennyi lenne 0 Ft-os folyószámla-egyenlegnél">Tárgyidőszaki</th>
              <th class="num" title="Az adófolyószámla nyitó egyenlege: tartozás (+) / túlfizetés (−)">Folyószámla</th>
              <th class="num">Befizetendő (Ft)</th><th>Határidő</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let t of l.tetelek" [class.bf-kezi]="t.osszeg === null || t.osszeg === undefined">
                <td><input type="text" [(ngModel)]="t.bevallas" (ngModelChange)="levelHtml = null">
                  <div class="halvany bf-megj" *ngIf="t.megjegyzes">{{ t.megjegyzes }}</div></td>
                <td><input type="text" class="bf-rov" [(ngModel)]="t.idoszak"></td>
                <td><input type="text" class="bf-adonem" maxlength="3" [(ngModel)]="t.adonem" (ngModelChange)="t.szamla = null; levelHtml = null" placeholder="pl. 290"></td>
                <td class="halvany">{{ t.szamla || (t.adonem ? 'küldéskor' : '—') }}</td>
                <td class="num halvany">{{ t.targyidoszaki != null ? (t.targyidoszaki | number:'1.0-0') : '' }}</td>
                <td class="num" [class.piros]="t.folyoszamla > 0" [class.bf-zold]="t.folyoszamla < 0" [title]="t.folyoszamla_megj || ''">
                  {{ t.folyoszamla ? ((t.folyoszamla > 0 ? '+' : '−') + (abs(t.folyoszamla) | number:'1.0-0')) : '' }}</td>
                <td><input type="number" class="bf-osszeg" [(ngModel)]="t.osszeg" (ngModelChange)="levelHtml = null"></td>
                <td><input type="date" [(ngModel)]="t.hatarido" (ngModelChange)="levelHtml = null"></td>
                <td><button type="button" class="kv-mini" title="Sor törlése" (click)="sorTorol(t)"><ion-icon name="trash-outline"></ion-icon></button></td>
              </tr>
            </tbody>
            <tfoot><tr><td colspan="6"><button type="button" class="ov-gomb" (click)="sorUj()"><ion-icon name="add-outline"></ion-icon>Sor</button></td>
              <td class="num"><b>{{ levelOsszeg | number:'1.0-0' }}</b></td><td colspan="2"></td></tr></tfoot>
          </table>
        </div>
        <div class="bf-folyo halvany" *ngIf="l.folyoszamla?.van">
          Az adófolyószámla (NAV, lekérve: {{ l.folyoszamla.lekerve || '—' }}) egyenlegével módosítva: tartozás növeli, túlfizetés csökkenti a befizetendőt.
          <span *ngIf="l.folyoszamla.egyeb?.length" class="piros"> Egyéb tartozás:
            <span *ngFor="let e of l.folyoszamla.egyeb; let u = last">{{ e.adonem }} {{ e.nev }}: {{ e.tartozas | number:'1.0-0' }} Ft{{ u ? '' : '; ' }}</span></span>
        </div>
        <div class="bf-folyo halvany" *ngIf="l.folyoszamla && !l.folyoszamla.van">Nincs letöltött adófolyószámla (Hatóság › Adófolyószámla) – a tárgyidőszaki összegekkel számol.</div>
        <div class="bf-hiany" *ngIf="l.hianyzo?.length">
          <b>Még nem készült el:</b>&nbsp;
          <span *ngFor="let h of l.hianyzo; let u = last">{{ h.bevallas }} ({{ h.idoszak }}){{ u ? '' : ', ' }}</span>
        </div>

        <div class="bf-ber" *ngIf="l.ber?.db">
          <b>Bér-mellékletek ({{ l.ber.ev }}. {{ l.ber.ho }}. hó, {{ l.ber.db }} számfejtés):</b>
          <label><input type="checkbox" [(ngModel)]="l.mellek.berlista"> Bérlista</label> <a (click)="pdfNyit('berlista')">megnéz</a>
          <label><input type="checkbox" [(ngModel)]="l.mellek.atutalas"> Átutalási lista</label> <a (click)="pdfNyit('atutalas')">megnéz</a>
          <label><input type="checkbox" [(ngModel)]="l.mellek.jarulek"> Járuléklista</label> <a (click)="pdfNyit('jarulek')">megnéz</a>
        </div>

        <div class="bf-elonezet" *ngIf="levelHtml" [innerHTML]="levelHtml"></div>

        <div class="nk-lab">
          <button type="button" class="ov-gomb" (click)="levelElonezet()"><ion-icon name="eye-outline"></ion-icon>Előnézet</button>
          <button type="button" class="ov-gomb fo" [disabled]="levelFut || !l.cimzett || !levelOsszeg" (click)="levelKuld()">
            <ion-icon [name]="levelFut ? 'hourglass-outline' : 'send-outline'"></ion-icon>{{ levelFut ? 'Küldés…' : 'Küldés' }}</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- ═══ BEFIZETÉSI ÉRTESÍTŐK – TÖMEGES ═══ -->
<ion-modal [isOpen]="!!tomeges" (didDismiss)="tomeges = null" class="ber-urlap-modal ber-szeles-modal" cssClass="ber-urlap-modal ber-szeles-modal">
  <ng-template>
    <ion-header><ion-toolbar class="kv-modal-fej"><ion-title>Befizetési értesítők – {{ ev }}. {{ ho }}. havi beadás</ion-title>
      <ion-buttons slot="end"><ion-button (click)="tomeges = null">Bezár</ion-button></ion-buttons></ion-toolbar></ion-header>
    <div class="nk-torzs" *ngIf="tomeges as tm">
      <div class="bf">
        <p class="halvany bf-sugo">A kijelölt ügyfelek az automatikusan összeállított levelet kapják. Ahol kézzel kell összeget megadni, vagy szerkesztenél,
          nyisd meg egyenként (Szerkesztés).</p>
        <div class="halvany" *ngIf="tm.betolt">Összeállítás…</div>
        <div class="tabla-wrap" style="margin:0" *ngIf="!tm.betolt">
          <table class="n-racs">
            <thead><tr><th></th><th>Ügyfél</th><th>E-mail</th><th class="num">Befizetendő</th><th>Megjegyzés</th><th>Kiküldve</th><th></th></tr></thead>
            <tbody>
              <tr *ngFor="let u of tm.ugyfelek">
                <td><input type="checkbox" [(ngModel)]="u.jelolt" [disabled]="!u.email || !u.osszeg"></td>
                <td>{{ u.nev }}<span class="cimke-bf" *ngIf="u.ber">bér</span></td>
                <td [class.piros]="!u.email">{{ u.email || 'nincs e-mail cím' }}</td>
                <td class="num">{{ u.osszeg | number:'1.0-0' }} Ft <span class="halvany">({{ u.tetel_db }})</span></td>
                <td class="halvany">
                  <span *ngIf="u.kezi_db">{{ u.kezi_db }} sor kézi összeggel · </span>
                  <span *ngIf="u.hianyzo_db">{{ u.hianyzo_db }} bevallás még nincs kész</span>
                </td>
                <td>{{ u.kuldve || '—' }}</td>
                <td><button type="button" class="ov-gomb" (click)="levelNyit(u.ugyfel_id)">Szerkesztés</button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="bf-ber">
          <b>Bér-mellékletek (ahol van számfejtés):</b>
          <label><input type="checkbox" [(ngModel)]="mellek.berlista"> Bérlista</label>
          <label><input type="checkbox" [(ngModel)]="mellek.atutalas"> Átutalási lista</label>
          <label><input type="checkbox" [(ngModel)]="mellek.jarulek"> Járuléklista</label>
        </div>
        <div class="nk-lab">
          <button type="button" class="ov-gomb fo" [disabled]="tomegesFut || !tomegesJelolt.length" (click)="tomegesKuld()">
            <ion-icon [name]="tomegesFut ? 'hourglass-outline' : 'send-outline'"></ion-icon>{{ tomegesFut ? 'Küldés…' : 'Küldés a kijelölteknek (' + tomegesJelolt.length + ')' }}</button>
        </div>
      </div>
    </div>
  </ng-template>
</ion-modal>

<!-- A bevallás-PDF láthatatlan lapképe (képernyőn kívül) -->
<app-bevallas-pdf #bevallasPdf [logo]="pdfLogo"></app-bevallas-pdf>
